"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CARD_TAPPABLE_SX = void 0;
exports.Tappable = Tappable;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var tokens_1 = require("../../tokens");
/**
 * カード 1 枚をまるごとタップ領域にするときの sx。
 * TicketCard / StoreCard で共通 (角丸 12px・ホバーで少し薄くなる)。
 */
exports.CARD_TAPPABLE_SX = {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    textDecoration: 'none',
    borderRadius: "".concat(tokens_1.radius.md, "px"),
    transition: 'opacity 0.15s ease',
    '&:hover': { opacity: 0.92 },
};
/**
 * href / onClick があるときだけ ButtonBase でラップする。
 * どちらも無い場合は Box でラップして非インタラクティブにする。
 *
 * 非インタラクティブでも sx は当てる。呼び出し側は行やカードの
 * レイアウト (display / width / height / padding / borderTop など) を
 * sx に載せているため、ここで捨てると崩れる。
 *
 * href あり / なしで分岐しているのは ButtonBase の型のため
 * (href を持つオーバーロードは href: string を要求し、`string | undefined`
 *  では解決できない)。
 */
function Tappable(_a) {
    var href = _a.href, onClick = _a.onClick, sx = _a.sx, children = _a.children;
    if (href) {
        return ((0, jsx_runtime_1.jsx)(material_1.ButtonBase, { href: href, onClick: onClick, sx: sx, children: children }));
    }
    if (onClick) {
        return ((0, jsx_runtime_1.jsx)(material_1.ButtonBase, { onClick: onClick, sx: sx, children: children }));
    }
    return (0, jsx_runtime_1.jsx)(material_1.Box, { sx: sx, children: children });
}
